// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App.vue"
import router from "./router"
// import * as connection from "@/data/connection"
// import * as lodash from "lodash"
// import Modernizr from "modernizr"
import VueCarousel from 'vue-carousel'
import VueI18n from 'vue-i18n';



/**
 * Vue configuration.
 */
Vue.config.productionTip = false;

Vue.set(Vue.prototype, "$lodash", require("lodash"));

// ===================
// 	Blocks
// ===================

require('@/components/blocks/blocks.js')

Vue.use(VueCarousel);
Vue.use(VueI18n);

// ===================
// 	Translations
// ===================

const messages = require('@/data/translations.json');

export const i18n = new VueI18n({
	locale: 'en',
	messages: messages
})

// ===================
// 	Helpers
// ===================

import { transform } from '@/data/helpers/date-pipe.js';
import { dateCdd } from '@/data/helpers/date-cdd.js';
import { stripHtml } from '@/data/helpers/strip-html.js';

// ===================
//  Filters
// ===================

Vue.filter("date", dateCdd);
Vue.filter("datePipe", transform);
Vue.filter("stripHtml", stripHtml);


// Global event bus.
export const bus = new Vue();
/**
 * Vue Initialization.
 */
/* eslint-disable no-new */
var vm = new Vue({
	el: "#app",
	router,
	template: "<App/>",
	components: { App },
	i18n
});

// Vue.prototype.$moderznir = Modernizr;
// console.log(Vue.prototype._.find())


// WEBPACK FOOTER //
// ./src/main.js